import CMS from "netlify-cms-app";
import clients from "./cms/collections/clients";
import legals from "./cms/collections/legals";
import news from "./cms/collections/news";
import resources from "./cms/collections/resources";
import testimonials from "./cms/collections/testimonials";
import pages from "./cms/pages";
import config from "./cms/settings";
import authors from "./cms/taxonomy/authors";

// Extend CMS
import { ColorControl, ColorPreview } from "netlify-cms-widget-colorpicker";
// import richText from 'netlify-cms-widget-richtext';



// custom preview
import "./cms/previews";
import i18n from './cms/i18n';
import taxonomy from './cms/taxonomy/taxonomy';

console.log('CMS LOCAL', process.env.CMS_LOCAL)

/* Auto matic setup
CMS.init();
*/

CMS.registerWidget("color", ColorControl, ColorPreview);
// CMS.registerWidget('richtext', RichTextControl, RichTextPreview)

CMS.init({
    config: {
        load_config_file: false,
        local_backend: (process.env.CMS_LOCAL === 'true') ? true : false,
        site_url: 'https://spacelabz.ai',
        //site_url: 'https://deploy-preview-10--spacelabs.netlify.app',
        backend: {
            name: 'git-gateway',
            branch: 'main',
            //branch: 'update-nov-23',
            repo: "nolafs/spacelabs"
        },
        publish_mode: "editorial_workflow",
        media_folder: 'site/static/uploads',
        public_folder: '/uploads',
        logo_url: 'https://spacelabz.ai/uploads/cms-icon.png',

        i18n,
        collections: [
            pages,
            resources('Projects', 'projects', null,true, true,  false, true, false),
            resources('Careers', 'careers', null, true, true, false, true, false, 'career'),
            news,
            authors,
            clients,
            testimonials,
            taxonomy,
            legals,
            config
        ],
    },
})
